import React from 'react';

import ContactForm from './ContactForm/ContactForm';

import './Contact.css';

const Contact = () => {
  return (
    <div className="page-container" id="contact">
      <h2>Nous contacter</h2>
      <div className="contact-half">
        <ContactForm />
      </div>
      <div className="contact-half">
        <h4>Restons en contact !</h4>
        <div className="contact-info">
          8, passage de Provins
          <br />
          74000 ANNECY
        </div>
        <div className="contact-info">07 55 60 20 80</div>
      </div>
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact/Contact.js